import React, { Component } from 'react'
import { Card, Button } from 'react-bootstrap'
import * as actions from '../actions'
import { connect } from 'react-redux'
import { reduxForm } from 'redux-form'
import { FORM_EDICION_CARATULA } from '../../../config/forms'
import { CircularProgress } from '@material-ui/core'
import { toast } from 'react-toastify'
import CamposCaratula from './CamposCaratula'
class DialogoComunicacionUpdate extends Component {
  constructor (props) {
    super(props)
    this.onSelect = this.onSelect.bind(this)
    this.changeArribo = this.changeArribo.bind(this)
    this.changeZarpada = this.changeZarpada.bind(this)
    this.changeBuque = this.changeBuque.bind(this)
    this.handleAgregarExportador = this.handleAgregarExportador.bind(this)
    this.handleSacarExportador = this.handleSacarExportador.bind(this)
    this.handleBuqueAceitero = this.handleBuqueAceitero.bind(this)
  }

  async componentDidMount () {
    const {
      id
    } = this.props
    this.props.getBuques()
    this.props.getGiros()
    this.props.getConsultaCaratula(id, this.props.change)
  }

  prepareEntity (buque, agencia) {
    return {
      searchSet: [
        { entity: 'buque', value: buque },
        { entity: 'agencia_maritima', value: agencia }
      ],
      fields: ['buque', 'agencia']
    }
  }

  onSelect (giro) {
    if (giro) {
      console.log('Giro Selecionado', giro.target.value)
      this.props.actualizarGiroSelecionado(giro.target.value)
    }
  }

  changeArribo (e) {
    const { change: formChange } = this.props
    formChange('fechaArribo', e.target.value)
  }

  changeZarpada (e) {
    const { change: formChange } = this.props
    formChange('fechaZarpada', e.target.value)
  }

  changeBuque (value) {
    console.log('buque', value)
    const { change: formChange } = this.props
    if (value !== null && value.imo === null) toast.info(`El buque seleccionado ${value.nombre} no tiene un # de IMO válido`)
    formChange('buque', value)
  }

  handleAgregarExportador () {
    const {
      actualizarExportador
    } = this.props
    actualizarExportador('EDIT')
  }

  handleSacarExportador (exportador) {
    const {
      sacarExportador,
      consultaCaratula
    } = this.props
    sacarExportador(consultaCaratula.id, exportador)
  }

  handleBuqueAceitero () {
    const {  
      changeBuqueAceitero 
    } = this.props
    changeBuqueAceitero()
  }

  render () {
    const {
      consultaCaratula,
      handleClose,
      handleSubmit,
      giros,
      buques,
      isRequesting,
      selectedGiro,
      buqueAceitero,
      onlyView,
      caratulaExportador,
      updateListaExportadoresSeleccionados
    } = this.props

    return (
      <div>
        <Card style={{ border: 'none' }}>
          <Card.Header style={{ backgroundColor: '#3f51b5', color: '#ffffff' }}>
            <Card.Text style={{ fontSize: '1.3rem', textAlign: 'center' }}>{!onlyView ? 'Edición de Carátula' : 'Vista de Carátula'}</Card.Text>
          </Card.Header>
          {!consultaCaratula && <div className='circular-progress-consulta-soap' >
            <CircularProgress />
          </div> }
          <Card.Body>
            {consultaCaratula && buques && <div>
              <CamposCaratula
                fechaArribo={consultaCaratula.fechaDeArribo}
                fechaZarpada={consultaCaratula.fechaDeZarpada}
                giros={giros}
                buques={buques}
                buque={{ nombre: consultaCaratula.nombreBuque, nombreCorto: consultaCaratula.buque }}
                onSelect={this.onSelect}
                selectedGiro={selectedGiro}
                isRequesting={isRequesting}
                changeBuque={this.changeBuque}
                changeArribo={this.changeArribo}
                changeZarpada={this.changeZarpada}
                buqueAceitero={buqueAceitero}
                cereal={consultaCaratula.cereal}
                handleBuqueAceitero={this.handleBuqueAceitero}
                onlyView={onlyView}
                caratulaExportador={caratulaExportador}
                handleAgregarExportador={this.handleAgregarExportador}
                handleSacarExportador={this.handleSacarExportador}
                updateListaExportadoresSeleccionados={updateListaExportadoresSeleccionados}/>
            </div> }
          </Card.Body>
          <div style={{ display: 'flex', justifyContent: 'center' }}>
            { (!onlyView) && <Button style={{ margin: '2%' }} onClick={handleClose} >Cancelar</Button> }
            { (!onlyView) && <Button style={{ margin: '2%' }} onClick={handleSubmit} >Guardar</Button> }
            { (onlyView) && <Button style={{ margin: '2%' }} onClick={handleClose} >Cerrar</Button> }
          </div>
        </Card>
      </div>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    consultaCaratula: state.comunicacionEmbarque.consultaCaratula,
    giros: state.comunicacionEmbarque.giros,
    buques: state.comunicacionEmbarque.buques,
    buqueAceitero: state.comunicacionEmbarque.buqueAceitero,
    selectedGiro: state.comunicacionEmbarque.selectedGiro,
    isRequesting: state.comunicacionEmbarque.requestingGiros,
    caratulaExportador: state.comunicacionEmbarque.caratulaExportador,
    exportadoresSeleccionados: state.comunicacionEmbarque.exportadoresSeleccionados
  }
}

const withRedux = connect(mapStateToProps, actions)

const withReduxForm = reduxForm({
  form: FORM_EDICION_CARATULA,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
  destroyOnUnmount: false,
  updateUnregisteredFields: true
})

export default withRedux(withReduxForm(DialogoComunicacionUpdate))
